<div class="group-list-container p-2  overflow-auto " >
    <h3 class="fs-normal m-0 p-2 pr-4 primary">קבוצות</h3>
    <ul class="group-list overflow-auto pr-3 primary">
        <li class="flex gap-1 align-items-center p-1 cursor-pointer" *ngFor="let group of companyGroups" [class.selected]="selectedGroup === group.name"
            (click)="selectGroup(group.name)">
            <span >•</span>
            {{ group.name }}
        </li>
    </ul>       
</div>
